module.exports = __webpack_public_path__ + "static/media/piper-fail-4.cf3c3ba0.svg";